import React from 'react';
import { useSelector } from 'react-redux';

import { useCustomerContext, useUserContext } from '../../utils/context';

const AuthCheckContainer = ({
	NotAuthenticatedRedirectComponent,
	AuthenticationExpiredComponent,
	DialogComponent,
	HeaderComponent,
	LoadingComponent,
	HomePageComponent,
}) => (isHome) => WrappedComponent => {
	// Create a wrapper component that uses hooks properly
	const AuthWrapper = (props) => {
		// Get isAuthenticated from Redux store using hooks
		const isAuthenticated = useSelector(state => state.auth.isAuthenticated);

		const { user, loading: userLoading } = useUserContext();
		const { customer, loading: customerLoading } = useCustomerContext();

		if ((userLoading && !user) || (customerLoading && !customer)) {
			return LoadingComponent ? <LoadingComponent /> : null;
		}

		if (isAuthenticated && (!user && !customer)) {
			return (
				<AuthenticationExpiredComponent />
			);
		}

		if (!isAuthenticated) {
			// could render a redirect here
			return (
				<NotAuthenticatedRedirectComponent
					to="/login"
				/>
			);
		}

		const ComponentToRender = isHome ? HomePageComponent : WrappedComponent;

		return (
			<>
				{ HeaderComponent ? <HeaderComponent /> : null }
				<ComponentToRender {...props} />
				{ DialogComponent ? <DialogComponent /> : null }
			</>
		);
	};

	// Return AuthWrapper directly since UserContext is now provided at navigation level
	// hack to preserve nav options. https://github.com/react-navigation/react-navigation/issues/2132#issuecomment-323125095
	if (WrappedComponent.navigationOptions) {
		AuthWrapper.navigationOptions = WrappedComponent.navigationOptions;
	}

	return AuthWrapper;
};

export default AuthCheckContainer;
